{
  "version": 1,
  "asset_id": "cd3d7df1-82a4-423c-93d8-e4a166403f07",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/cd3d7df1-82a4-423c-93d8-e4a166403f07/beylikduzu-hizli-elektrikci-7-24-dukkan-5.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/cd3d7df1-82a4-423c-93d8-e4a166403f07/beylikduzu-hizli-elektrikci-7-24-dukkan-5.jpg",
  "original_filename": "beylikduzu-hizli-elektrikci-7-24-dukkan-5.jpg",
  "size": 500047,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:13:43Z"
}
